import {
  SET_EDIT_AUTO_MODAL_SHOW_SUCCESS,
  SEND_AUTO_PARTICIPANT_DATA_EDITED,
  SEND_AUTO_PARTICIPANT_DATA_EDITED_ERROR,
  SEND_AUTO_PARTICIPANT_DATA_EDITED_SUCCESS,
  SET_EDIT_AUTO_MODAL_FUNCTION_SUCCESS,
  SET_EDIT_AUTO_START_DATE_SUCCESS,
  SET_EDIT_AUTO_END_DATE_SUCCESS
} from './EditAutoParticipantModal.actions'

const initialState = {
  error: false,
  loading: true,
  showEditAutoParticipantModal: false,
  participantSelected: {},
  fullName: '',
  role: '',
  dni: '',
  email: '',
  functionId: '',
  processId: '',
  isForeignPerson: false,
  participantId: '',
  participantDetailId: '',
  originalProcessId: '',
  originalFunctionId: '',
  startDate: '',
  endDate: '',
  isManual: null,
  processName: '',
  functionName: '',
  participantProcessId: ''
}

/**
 * The reducer for the Edit Automatic Participants List
 */
const editManualParticipantModalReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_EDIT_AUTO_MODAL_SHOW_SUCCESS: {
      return {
        ...state,
        showEditAutoParticipantModal: payload.showEditAutoParticipantModal,
        participantSelected: payload.participantSelected,
        fullName: payload.fullName,
        role: payload.role,
        dni: payload.dni,
        email: payload.email,
        functionId: payload.functionId,
        processId: payload.processId,
        isForeignPerson: payload.isForeignPerson,
        participantId: payload.participantId,
        participantDetailId: payload.participantDetailId,
        originalProcessId: payload.originalProcessId,
        originalFunctionId: payload.originalFunctionId,
        startDate: payload.startDate,
        endDate: payload.endDate,
        isManual: payload.isManual,
        processName: payload.processName,
        functionName: payload.functionName,
        participantProcessId: payload.participantProcessId,
        loading: false,
        error: false
      }
    }
    case SET_EDIT_AUTO_START_DATE_SUCCESS: {
      return { ...state, startDate: payload.startDate }
    }
    case SET_EDIT_AUTO_END_DATE_SUCCESS: {
      return { ...state, endDate: payload.endDate }
    }
    case SEND_AUTO_PARTICIPANT_DATA_EDITED: {
      return { ...state, loading: true, error: false }
    }
    case SEND_AUTO_PARTICIPANT_DATA_EDITED_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case SEND_AUTO_PARTICIPANT_DATA_EDITED_SUCCESS: {
      return {
        ...state,
        loading: true,
        error: false
      }
    }
    case SET_EDIT_AUTO_MODAL_FUNCTION_SUCCESS: {
      return {
        ...state,
        functionId: payload.functionId,
        loading: false,
        error: false
      }
    }
    default: {
      return state
    }
  }
}

export default editManualParticipantModalReducer
